"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = install;

var _capitalFinderApi = _interopRequireDefault(require("@alliedcrowds/capital-finder-api"));

require("regenerator-runtime/runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var cfStore = require('./store.js')["default"];

function install() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    resultsPerPage: 10,
    maxResults: -1,
    apiKey: undefined
  };
  cfStore.state.api = new _capitalFinderApi["default"].api(config.apiUrl, config, config.clientId, config.clientSecret);
  cfStore.modules.user.state.apiToken = config.apiKey != undefined ? config.apiKey : '';
  cfStore.modules.searchResults.state.maxResults = config.maxResults;
  cfStore.modules.searchResults.state.resultsPerPage = config.resultsPerPage;
  cfStore.modules.searchResults.state.range = [0, config.resultsPerPage];
  return cfStore;
}


// WEBPACK FOOTER //
// ../capital-finder-vuex/lib/index.js